import Api from 'libs/api';
import AuthService from 'services/Auth';

class DishCategoriesApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/dish_categories`);
  }
}

export default DishCategoriesApi;
